import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LocationService {
  constructor(private http: HttpClient) {}

  validPostcode(postcode: string): Promise<any> {
    return this.validPostcodeSync(postcode).toPromise();
  }

  findPostcode(postcode: string): Promise<any> {
    return this.http.get('/api/location/postcode/' + postcode).toPromise();
  }

  validPostcodeSync(postcode: string) {
    return this.http.get('/api/location/validPostcode/' + postcode);
  }
}
